export default "__VITE_ASSET__LED28aBG__"